import { ChevronLeft } from 'lucide-react';
import { cn } from '../lib/utils';

export default function TopBar({ title, subtitle, onBack, right, className, children }) {
  return (
    <header className={cn('safe-t sticky top-0 z-20 bg-bg/95 backdrop-blur', className)}>
      <div className="mx-auto flex max-w-lg items-center gap-2 px-3 pb-2 pt-2">
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            aria-label="Back"
            className="-ml-1 flex h-11 w-11 shrink-0 items-center justify-center rounded-full active:bg-sunken"
          >
            <ChevronLeft className="h-6 w-6" />
          </button>
        )}
        <div className="min-w-0 flex-1">
          <h1 className="font-cond truncate text-[26px] font-bold leading-none tracking-tight">{title}</h1>
          {subtitle && <p className="clamp-2 mt-1 text-[14px] leading-tight text-ink2">{subtitle}</p>}
        </div>
        {right && <div className="flex shrink-0 items-center gap-1">{right}</div>}
      </div>
      {children}
    </header>
  );
}
